import { type StoreState } from '../../../store'
import { key } from './moves.reducer'

const getMoveStore = (state: StoreState) => state[key]

export const moveId = (state: StoreState) => getMoveStore(state).moveId

export const isLoggingOut = (state: StoreState) => getMoveStore(state).isLoggingOut
